export class PaymentType {
  public constructor() {
    this.PaymentTypeId = 0;
    this.PaymentType = '';
    this.Descr = '';
  }

  public PaymentTypeId: number;
  public PaymentType: string;
  public Descr: string;
  public GLAccountNum: string;
  public NormalBalance: string;
  public DateChanged: Date;
  public DateCreated: Date;
  public DebitAccount: string;
  public CreditAccount: string;
  public CashBasis: boolean;
  public CreditCardType: boolean;
  public AccountingPackageID: number;
  public CCGatewayID: number;
  public CashType: boolean;
  public CheckType: boolean;
  public ACHType: boolean;
}
